export function subtractSeconds(totalTime: number, secondsSubtract: number): number {
   // subtract secondsSubtract from totalTime and assign the result to the variable newTime
   const newTime: number = totalTime - secondsSubtract;
   // return the result of the subtraction
   return newTime;
}
